import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const getTableColumnsList = ({ tableId, keyword, pageNumber }) => {
  return axios.get(
    `/api/v1/integration/data-dictionaries/tables/${tableId}/columns?pageSize=100&pageNumber=${pageNumber}&keyword=${keyword}`
  );
};

export const useGetTableColumnsList = ({
  tableId,
  keyword,
  pageNumber,
  config,
}) => {
  const { addNotification } = useNotificationStore();

  const queryKey = ['tableColumns'];
  if (tableId !== null) {
    queryKey.push(tableId, keyword, pageNumber);
  }
  return useQuery(
    queryKey,
    () => getTableColumnsList({ tableId, keyword, pageNumber }),
    {
      ...config,
      onError: (error) => {
        addNotification({ type: 'error', title: error.message });
      },
    }
  );
};
